module.exports = __webpack_public_path__ + "img/mouse-scroll-mobile.eab120f0.svg";